"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

class EvaluationSectionVersion {
  static thaw(evaluationSectionVersionObj) {
    if (evaluationSectionVersionObj == null) return null;
    const evaluationSectionVersion = new EvaluationSectionVersion();
    if (evaluationSectionVersionObj.evaluationVersionId != null) evaluationSectionVersion.setEvaluationVersionId(evaluationSectionVersionObj.evaluationVersionId);
    if (evaluationSectionVersionObj.evaluationSectionId != null) evaluationSectionVersion.setEvaluationSectionId(evaluationSectionVersionObj.evaluationSectionId);
    return evaluationSectionVersion;
  }

  static thawList(evaluationSectionVersionObjList) {
    if (evaluationSectionVersionObjList == null) return [];
    var evaluationSectionVersions = [];

    for (var i = 0; i < evaluationSectionVersionObjList.length; i++) {
      evaluationSectionVersions.push(EvaluationSectionVersion.thaw(evaluationSectionVersionObjList[i]));
    }

    return evaluationSectionVersions;
  }

  static freeze(evaluationSectionVersion) {
    if (evaluationSectionVersion == null) return null;
    var evaluationSectionVersionObj = {};
    if (evaluationSectionVersion.getEvaluationVersionId() != null) evaluationSectionVersionObj.evaluationVersionId = evaluationSectionVersion.getEvaluationVersionId();
    if (evaluationSectionVersion.getEvaluationSectionId() != null) evaluationSectionVersionObj.evaluationSectionId = evaluationSectionVersion.getEvaluationSectionId();
    return evaluationSectionVersionObj;
  }

  static freezeList(evaluationSectionVersions) {
    if (evaluationSectionVersions == null) return [];
    var evaluationSectionVersionObjList = [];

    for (var i = 0; i < evaluationSectionVersions.length; i++) {
      evaluationSectionVersionObjList.push(EvaluationSectionVersion.freeze(evaluationSectionVersions[i]));
    }

    return evaluationSectionVersionObjList;
  }

  constructor() {
    this.setEvaluationVersionId(null);
    this.setEvaluationSectionId(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setEvaluationVersionId(evaluationVersionId) {
    this.evaluationVersionId = evaluationVersionId;
  }

  setEvaluationSectionId(evaluationSectionId) {
    this.evaluationSectionId = evaluationSectionId;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getEvaluationVersionId() {
    return this.evaluationVersionId;
  }

  getEvaluationSectionId() {
    return this.evaluationSectionId;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluationSectionVersion;